import { render, staticRenderFns } from "./incidentReportQrCodeFormLong.vue?vue&type=template&id=2d808a46"
import script from "./incidentReportQrCodeFormLong.vue?vue&type=script&lang=js"
export * from "./incidentReportQrCodeFormLong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports